import React, { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { FormEnums } from "models/enums";
import { ReceiptSendBackFormViewProps } from "models/propTypes/receiptPropTypes";
import { FormHandles } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { ReceiptFormTypes } from "models/formTypes";
//#endregion
//#region components
import GenericForm from "components/common/forms/genericForm";
//#endregion

const ReceiptSendBackForm: ForwardRefRenderFunction<FormHandles, ReceiptSendBackFormViewProps> = (props, ref) => {
  return (
    <GenericForm<ReceiptFormTypes.SendBack>
      formRef={ref}
      {...props}
      fields={{
        message: {
          label: TranslationKeys.Common.Message,
          type: FormEnums.FormFieldType.TEXTAREA,
          icon: IconDefinitionConstants.WCommentDots,
        },
      }}
    />
  );
};

export default forwardRef(ReceiptSendBackForm);
